module.exports = __webpack_public_path__ + "img/sa.8950e015.svg";